// Lifted out of config.availableSpares (spec §4.1: constants are not state).
export const SPARES_OPTIONS: number[] = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26];
